var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PipelineMenu',{attrs:{"small-mobile-items":"","current-step":_vm.currentStep,"pipeline-items":_vm.pipelineItems,"step-history":_vm.stepHistory},on:{"goToStep":_vm.goToStep}})}
var staticRenderFns = []

export { render, staticRenderFns }